import React from 'react';

export const PegStatus = () => {
  return (
    <div className="peg-pill" aria-label="USDN peg status">
      <span className="peg-dot" aria-hidden="true"></span>
      <span>1 USDN = $1.0000</span>
    </div>
  );
};
